export const userSteps = [
    {
    target: ".j_u_audit",
    content: "View the audit trail to track all actions and activity related to users.",
    placement: "left",
  },
  {
    target: ".j_srch",
    content:
      "Search users by name, email, or other attributes to quickly locate them in the system.",
    placement: "bottom",
  },
  {
    target: ".j_fil",
    content:
      "Use filters to narrow down users based on app access level, status, or other criteria.",
    placement: "bottom",
  },
  {
    target: ".j_u_create",
    content:
      "Click here to create a new user and assign them access to the application.",
    placement: "left",
  },
  {
    target: ".j_tbl1_nam",
    content:
      "This column displays the user's name for identification.",
    placement: "top",
  },
  {
    target: ".j_tbl2_app",
    content:
      "This column shows the application access level (e.g., Admin, Manager, User).",
    placement: "top",
  },
  {
    target: ".j_tbl3_ema",
    content:
      "This column lists the user's email address.",
    placement: "top",
  },
  {
    target: ".j_tbl4_cre",
    content:
      "This column shows who created the user along with the creation date and time.",
    placement: "top",
  },
  {
    target: ".j_tbl5_sta",
    content:
      "This column shows the user’s current status (e.g., Active). You can also edit or delete the user here.",
    placement: "left",
  },
   {
    target: ".j_tbl6_col6",
    content:
      "You can also edit or delete the user using action buttons present in this column.",
    placement: "left",
  },
];
